import React, { useContext, useEffect } from 'react';

import { RouteProps } from 'react-router';

import { Box } from '@mui/material';

import Spinner from '~/components/Common/Spinner';

import useCurrentUser from '~/hooks/useCurrentUser';

import type { LegacyContext } from './LegacyContextType';
import { AuthContext } from './Router';

type Props = RouteProps;

export default function HomeRoute({ children }: Props) {
  const context = useContext<LegacyContext>(AuthContext);
  const { loading, authenticated, user } = context ?? {};

  const { setCurrentUserState } = useCurrentUser();

  useEffect(() => {
    setCurrentUserState({ isLoading: loading, isAuthenticated: authenticated, user: user ?? null });
  }, [loading, authenticated, user, setCurrentUserState]);

  if (loading) {
    return (
      <Box height="100vh">
        <Spinner />
      </Box>
    );
  }

  return children;
}
